module.exports = __webpack_public_path__ + "static/media/dashboard (1).0b92c1ba.png";